// extracted by mini-css-extract-plugin
export var fullGrid = "_3k-3";
export var pdpPreviewContainer = "_3k-1";
export var previewContainer = "_3k-0";
export var togglePreviewContainer = "_3k-2";